import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { BusInfo } from '../app.model';
import { StateService } from './state-service.service';

@Injectable()
export class StateServiceHttp extends StateService {
  constructor(private http: HttpClient) {
    super();
  }

  getHeartbeat(id: string): Promise<BusInfo> {
    let headers: HttpHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });

    let endpoint = `${environment.apiBaseUrl}/rest/bus/info`;
    return this.http.post<BusInfo>(endpoint, { vehicleId: id }, { headers: headers }).toPromise();
  }
}
